import startSearch from '../../actions/search/startSearch';
import { getFilePickerStore } from '../../store/filePickerStore';
import { orchestrator } from 'satcheljs';
import { startSearch as startSearchAction, startSearchSession } from 'owa-search-actions';
import { SearchScenarioId, getScenarioStore } from 'owa-search-store';

orchestrator(startSearchAction, actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.FilesPicker) {
        return null;
    }
    const searchStore = getScenarioStore(SearchScenarioId.FilesPicker);
    const searchQuery = searchStore.searchText;

    // SearchSessionGuid is set in startSearchSession as a part of initialization code.
    // If it was not set due to lazy loading of the script and user intiating the search mean while
    // we will call startSearchSession here again
    if (!searchStore.searchSessionGuid) {
        startSearchSession(
            actionMessage.actionSource,
            true /* shouldStartSeach */,
            SearchScenarioId.FilesPicker
        );
        return null;
    }

    startSearch(getFilePickerStore().viewState, searchQuery);
});
